// Footer.js
import React from "react";
import "./Footer.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Footerimg from "./shreekrushna-logo-min.png";
import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import facebook from './IconSideBar/facebook (1).svg';
import WhatsApp from './IconSideBar/whatsapp.svg';
import Instagram from './IconSideBar/instagram.svg';
import YouTube from './IconSideBar/youtube.svg';
import linkedin from './IconSideBar/linkedin-svgrepo-com.svg';

const Footer = () => {

  const socialLinks = [
    // { href: "tel:+919766690774", icon: phone, tooltip: "Call Now", className: "phone" },
    { href: "https://www.facebook.com/people/Shrikrishna-Arogyam/100093267866282/?paipv=0&eav=AfZ_PEZMuFt_65oNZkSi8nd39FZaPVzEBXe9C6ed62cTXo2bfRYyy5vFC6FfxnjWRF4", icon: facebook, tooltip: "Facebook", className: "facebook" },
    { href: "https://wa.me/919766690774?text=Hello", icon: WhatsApp, tooltip: "WhatsApp", className: "whatsapp" },
    { href: "https://wa.me/919997119959?text=Hello", icon: WhatsApp, tooltip: "WhatsApp", className: "whatsapp" },
    { href: "https://www.instagram.com/shri_krishnaarogyam/", icon: Instagram, tooltip: "Instagram", className: "instagram" },
    { href: "https://www.youtube.com/channel/UCsUN2f53Zvw2UtaIOirzowg", icon: YouTube, tooltip: "YouTube", className: "youtube" },
    { href: "https://www.linkedin.com/in/shrikrishna-arogyam-massage-therapy-and-massage-home-service-55091127a/", icon: linkedin, tooltip: "LinkedIn", className: "linkedin" },
  ];
  return (
    <footer className="footer">

      <div className="footer-content">
        <div className="footer-section company">
          <p> </p>
          <Image src={Footerimg} className="FooterImg" />
          {/* Other Social Media Icons (Aligned Right) */}
          <h5>Connect with us</h5>
          <div className="social-icons-container">
            {socialLinks.map((item, index) => (
              <OverlayTrigger key={index} placement="bottom" overlay={<Tooltip id={`tooltip-${index}`}>{item.tooltip}</Tooltip>}>
                <a href={item.href} className={`icon ${item.className}`} target="_blank" rel="noopener noreferrer">
                  <img src={item.icon} alt={item.tooltip} width="30" />
                </a>
              </OverlayTrigger>
            ))}
          </div>
        </div>

        <div className="footer-section Componayproducts">
          <h5>Our Services</h5>
          <ul>
            <NavLink
              to={"/cupping-therapy-treatment"}
              className="Footer_Tritment_links"
            >
              <li> Cupping Therapy Treatment</li>
            </NavLink>

            <NavLink
              to={"/sciatica-pain-relief-massage"}
              className="Footer_Tritment_links"
            >
              {" "}
              <li> Sciatica Pain Relief Massage</li>
            </NavLink>

            <NavLink
              to={"/ayurvedic-body-massage"}
              className="Footer_Tritment_links"
            >
              <li> Ayurvedic Body Massage</li>
            </NavLink>

            <NavLink
              to={"/deep-tissue-massage"}
              className="Footer_Tritment_links"
            >
              {" "}
              <li> Deep Tissue Massage</li>
            </NavLink>

            <NavLink to={"/full-body-waxing"} className="Footer_Tritment_links">
              {" "}
              <li>Full Body Waxing </li>{" "}
            </NavLink>
          </ul>
        </div>

        <div className="footer-section  contact">
          <h5>Get in Touch</h5>
          <p>
            <i className="fas fa-home"></i>
            <a
              href="https://maps.app.goo.gl/BZHkWog4zMSqYQg69"
              target="_blank"
              rel="noopener noreferrer"
            >
              S, NO.82/30/1/31/1 Sagar Colony, DP Rd, near Srishti apartment,
              Sagar Colony, Guruganesh Nagar, Kothrud, Pune, Maharashtra 411038
            </a>
          </p>

          <p>
            <i className="fas fa-envelope"></i>
            <a href="mailto:kpatil1808@gmail.com" target="_blank" rel="noopener noreferrer">
              kpatil1808@gmail.com
            </a>
          </p>

          <p>
            <i className="fas fa-phone"></i>
            <a href="tel:+919766690774">+919766690774  </a> /   <a href="tel:+919997119959">+919997119959</a>
          </p>

        </div>

        <div className="footer-section  gogole_link">
          <h5>Google Reviews </h5>
          <iframe
            src="https://widgets.sociablekit.com/google-reviews/iframe/25608247"
            title="google review"
            frameborder="0"
            width="100%"
            height="1000"
            className="google_revive"
          ></iframe>
        </div>


      </div>

      <div className="footer-bottom">
        <span className="ShriKrishna-name">
          <span className="kgf">©2024 Copyright : </span>
          ShriKrishna Arogyam Massage And Therapy Treatments
        </span>

        <span className="nebula-color">
          <span className="kgf">Developed By -</span>N
          <span className="e-color">e</span>bula Technology
        </span>
      </div>
    </footer>
  );
};

export default Footer;
